import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14bad476"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-admission" }
const _hoisted_2 = { class: "create-admission__form grid grid-cols-2 gap-3" }
const _hoisted_3 = { class: "text-sm text-gray-400" }
const _hoisted_4 = {
  key: 0,
  class: "text-lg font-semibold mt-6"
}
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_7 = { class: "create-admission__form" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Добавление товара", -1))
const _hoisted_9 = { class: "grid grid-cols-1 lg:grid-cols-4 gap-3 items-start" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_11 = { class: "flex items-center justify-end mt-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_select, {
        class: "mt-2",
        placeholder: "Склад",
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_validation.warehouseId.$error,
        "validation-errors": _ctx.state_validation.warehouseId.$errors,
        loading: _ctx.data_state.warehouses.is_loading,
        failed: _ctx.data_state.warehouses.is_failed,
        "error-text": "При получении списка складов произошла ошибка",
        options: _ctx.data_state.warehouses.list,
        value: _ctx.state.warehouseId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.warehouseId) = $event)),
        "search-by": "city",
        onRefresh: _ctx.loadWarehouses
      }, {
        "selected-option": _withCtx(({ option }) => [
          _createTextVNode(" Склад " + _toDisplayString(option.city), 1)
        ]),
        option: _withCtx(({ option }) => [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, "Склад " + _toDisplayString(option.city), 1),
            _createElementVNode("p", _hoisted_3, _toDisplayString(option.full_address), 1)
          ])
        ]),
        _: 1
      }, 8, ["disabled", "is-invalid", "validation-errors", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_the_input, {
        disabled: _ctx.state.is_loading,
        placeholder: "Количество разобранных паллет",
        value: _ctx.state.palletAmount,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.palletAmount) = $event)),
        "is-invalid": _ctx.state_validation.palletAmount.$error,
        "validation-errors": _ctx.state_validation.palletAmount.$errors
      }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
    ]),
    (Boolean(_ctx.state.items.length))
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Товары (" + _toDisplayString(_ctx.state.items.length) + ") ", 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.items, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "px-4 py-3 mt-3 bg-white border flex items-center justify-between",
        key: `item-${i}`
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(item.tmc_name), 1),
          _createElementVNode("p", null, "количество: " + _toDisplayString(item.amount), 1)
        ]),
        _createVNode(_component_the_button, {
          disabled: _ctx.state.is_loading,
          class: "red text small",
          onClick: ($event: any) => (_ctx.removeItem(i))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 2
        }, 1032, ["disabled", "onClick"])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_the_select, {
          class: "mt-2",
          disabled: _ctx.state.is_loading,
          placeholder: "ТМЦ",
          "is-invalid": _ctx.item_validation.tmc.$error,
          "validation-errors": _ctx.item_validation.tmc.$errors,
          loading: _ctx.data_state.tmc.is_loading,
          failed: _ctx.data_state.tmc.is_failed,
          "error-text": "При получении списка ТМЦ произошла ошибка",
          options: _ctx.data_state.tmc.list,
          value: _ctx.item_state.tmc,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item_state.tmc) = $event)),
          "infinite-scroll": "",
          "search-by": "name",
          onChange: _ctx.onTmcChange,
          onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadTMC(_ctx.data_state.tmc.pagination.current_page))),
          onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreTMC(_ctx.data_state.tmc.pagination.current_page + 1))),
          onSearch: _ctx.searchTMC,
          onOptionBySearch: _ctx.unshiftFindedTMC
        }, null, 8, ["disabled", "is-invalid", "validation-errors", "loading", "failed", "options", "value", "onChange", "onSearch", "onOptionBySearch"]),
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_the_select, {
              key: 0,
              placeholder: "Клиент",
              loading: _ctx.data_state.companies.is_loading,
              failed: _ctx.data_state.companies.is_failed,
              "error-text": "При получении списка клиентов произошла ошибка",
              "is-invalid": _ctx.item_validation.companyId.$error,
              "validation-errors": _ctx.item_validation.companyId.$errors,
              options: _ctx.data_state.companies.list,
              value: _ctx.item_state.companyId,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item_state.companyId) = $event)),
              "infinite-scroll": "",
              "search-without-refresh": "",
              onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadCompanies(1))),
              class: "mt-2"
            }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value"]))
          : _createCommentVNode("", true),
        _createVNode(_component_the_input, {
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.item_validation.amount.$error,
          "validation-errors": _ctx.item_validation.amount.$errors,
          placeholder: "Количество",
          value: _ctx.item_state.amount,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item_state.amount) = $event))
        }, null, 8, ["disabled", "is-invalid", "validation-errors", "value"]),
        _createVNode(_component_the_button, {
          class: "primary text small mt-2 py-3",
          disabled: _ctx.state.is_loading,
          onClick: _ctx.addItem
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_the_button, {
        class: "primary small",
        loading: _ctx.state.is_loading,
        onClick: _ctx.submitForm
      }, {
        default: _withCtx(() => [
          _hoisted_12,
          _createTextVNode(" Создать заявку на поступление ")
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}